/** Validate API responses before handing them to the browser's navigation API. */
export function getSafeRedirectUrl(value: unknown): string {
  if (typeof value !== 'string') throw new Error('Invalid OAuth redirect URL');
  const url = new URL(value);
  if (url.protocol !== 'https:' && url.protocol !== 'http:') {
    throw new Error('Invalid OAuth redirect URL');
  }
  return url.href;
}
